import { render, staticRenderFns } from "./Comment.vue?vue&type=template&id=4610aae0&scoped=true"
import script from "./Comment.vue?vue&type=script&lang=ts"
export * from "./Comment.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4610aae0",
  null
  
)

export default component.exports